import { render, staticRenderFns } from "./LayoutReportWithBanner.vue?vue&type=template&id=13889416&"
import script from "./LayoutReportWithBanner.vue?vue&type=script&lang=ts&"
export * from "./LayoutReportWithBanner.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutReportWithBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
